import { ServiceFetch } from '../service-fetch'

export default class FactPurchaseReturnModel extends ServiceFetch {
    getFactPurchaseReturnBy = (data) => this.authFetch({
        url: 'fact-invoice-supplier/getFactPurchaseReturnBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}